import { Building2, Target, Sparkles, Users, ShieldCheck, Rocket, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import LandingShell from "../components/LandingShell";
import Btn from "../components/Btn";

const PILLARS = [
  { icon: Target, title: "Fokus Ujian Seleksi", desc: "Dirancang khusus untuk SNBT, CPNS/ASN, dan Sekolah Kedinasan — materi, format, dan penilaian mengikuti ujian sesungguhnya." },
  { icon: Sparkles, title: "Belajar Rasa Main Game", desc: "Sistem RPG: EXP, level, skill tree, badge, energi & token — belajar jadi seru dan bikin nagih." },
  { icon: Users, title: "Kompetitif & Komunitas", desc: "1v1 Arena, Study Guild, dan Tryout Akbar nasional membuat belajar terasa hidup bersama ribuan pejuang." },
];

export default function TentangKami() {
  return (
    <LandingShell title="Tentang Kami" icon={Building2}
      subtitle="Mengenal SkorUp.io lebih dekat — siapa kami, bergerak di bidang apa, dan apa yang kami sediakan.">
      <div className="space-y-6" data-testid="tentang-page">
        <div className="card-chunky p-6 sm:p-8">
          <div className="inline-flex items-center gap-2 bg-su-secondary/20 text-su-secondaryShadow px-3 py-1.5 rounded-full font-heading font-extrabold text-xs mb-4">
            <GraduationCap className="w-4 h-4" /> Platform EdTech Persiapan Ujian
          </div>
          <p className="text-su-text font-medium text-lg leading-relaxed">
            <b>SkorUp.io</b> adalah platform <b>education technology (EdTech)</b> yang bergerak di bidang
            <b> persiapan ujian seleksi</b> di Indonesia — mencakup <b>SNBT</b> (masuk PTN), <b>CPNS/ASN</b>,
            dan <b>Sekolah Kedinasan</b>. Kami mengubah proses belajar yang biasanya membosankan menjadi
            pengalaman <b>gamified</b> yang seru, terukur, dan efektif.
          </p>
          <p className="text-su-muted font-medium mt-4 leading-relaxed">
            Kami menyediakan <b>simulasi tryout CBT</b> menyerupai ujian asli, <b>bank soal</b> yang terus
            diperbarui, <b>drill</b> latihan per materi, <b>1v1 Quiz Arena</b>, <b>Study Guild</b>,
            <b> modul materi</b>, hingga <b>Tryout Akbar</b> berskala nasional lengkap
            dengan sistem peringkat dan hadiah. Semua dalam satu platform, bisa diakses kapan saja.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {PILLARS.map((p) => (
            <div key={p.title} className="card-chunky p-6" data-testid={`tentang-pillar-${p.title}`}>
              <div className="w-12 h-12 rounded-2xl bg-su-primary/12 grid place-items-center mb-3">
                <p.icon className="w-6 h-6 text-su-primary" />
              </div>
              <h3 className="font-heading font-black text-lg mb-1">{p.title}</h3>
              <p className="text-su-muted font-medium text-sm">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="card-chunky p-6 sm:p-8 grid sm:grid-cols-3 gap-4">
          <div className="flex items-start gap-3"><ShieldCheck className="w-6 h-6 text-su-success shrink-0" /><div><p className="font-heading font-black">Misi</p><p className="text-sm text-su-muted font-medium">Memberi akses persiapan ujian berkualitas & terjangkau untuk semua.</p></div></div>
          <div className="flex items-start gap-3"><Rocket className="w-6 h-6 text-su-danger shrink-0" /><div><p className="font-heading font-black">Visi</p><p className="text-sm text-su-muted font-medium">Menjadi teman belajar #1 pejuang seleksi di Indonesia.</p></div></div>
          <div className="flex items-start gap-3"><Building2 className="w-6 h-6 text-su-primary shrink-0" /><div><p className="font-heading font-black">Dikelola oleh</p><p className="text-sm text-su-muted font-medium">PT. Ruang Karya Teknologi.</p></div></div>
        </div>

        <div className="text-center pt-2">
          <Link to="/auth"><Btn size="lg" data-testid="tentang-cta">Mulai Belajar Gratis</Btn></Link>
        </div>
      </div>
    </LandingShell>
  );
}
